import { BaseApiService } from "Apis/Service/BaseApiService";
import { IShiftController } from "Interfaces/Controllers/IShiftController";
import { IEnvConfigUtils } from "Interfaces/Utils/IEnvConfigUtils";
import { inject, injectable } from "inversify";
import { Shift } from "Models/Shifts/Shift";
import Types from "ServiceProvider/Types";
import request from "../BaseRequest";

@injectable()
export class ShiftController extends BaseApiService implements IShiftController {
    constructor(@inject(Types.IEnvConfigUtils) envConfigUtils: IEnvConfigUtils) {
        super(envConfigUtils, "shifts");
    }

    public async hasAreaShiftsForCompanyAsync(): Promise<boolean> {
        this.init();

        const response = await request
            .get(`${this.endpoint}/company/hasareashifts`)
            .set(this.headers);

        return response.body as boolean;
    }

    public async getCompanyShiftsAsync(): Promise<Shift[]> {
        this.init();

        const response = await request
            .get(`${this.endpoint}/company`)
            .set(this.headers);

        return response.body as Shift[];
    }

    public async getAreaShiftsAsync(areaId: number): Promise<Shift[]> {
        this.init();

        const response = await request
            .get(`${this.endpoint}/area/${areaId}`)
            .set(this.headers);

        return response.body as Shift[];
    }
}


// WEBPACK FOOTER //
// ./src/Apis/Controllers/ShiftController.ts